import React, {  useRef,useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from "react-redux"; 
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"  
import { useNavigate } from 'react-router-dom'; 
import { ENDPOINT } from "constants/variables"; 
import Box from '@mui/material/Box';  
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import "css/generalSettings.css";
import "css/customDialog.css";
import MenuItem  from "@mui/material/MenuItem"; 
import SendIcon from '@mui/icons-material/Send'; 
import Textarea from '@mui/joy/Textarea';
import { TextField } from '@mui/material';
import ReportTemplateNT from './ReportTemplateNT'; 
import PropTypes from 'prop-types';  

const initialStateFormNT = {
  id : "",
  ownformnt_id : "", 
  defaultStore_id:0, 
  useraccount_id:0,

  defaultformatnumber:1,
  isFinished:true,
  isScanned:false,
  preiddoc_sheet : "",
  sufiddoc_sheet : 0,

  number_nt: "",
  init_date_nt: "",
  end_date_nt: "",
  isindividual:false,
  ismultiple:true,
  frecuency: "",
  number_nt_refused: "",
  isemergency:false,
  reason_emergency: "",
   
  formopttrasstore_id: 0,
  opt_tras_store_id : 0,
  opt_tras_documnettype_id : 1,
  opt_tras_documentid : "",
  opt_tras_tradename : "",
  opt_tras_name : "",
  opt_tras_contactname : "",
  opt_tras_roadtype :  "",
  opt_tras_street : "",
  opt_tras_country_id:  1,
  opt_tras_country_name: "",
  opt_tras_province_id: 30,
  opt_tras_province_name: "",
  opt_tras_postalcode_id: 6911,
  opt_tras_postalcode_code: "",
  opt_tras_postalcode_name: "",
  opt_tras_community_id:  6, 
  opt_tras_community_name: "",
  opt_tras_phone: "",
  opt_tras_email: "",
  opt_tras_nima: "",
  opt_tras_cnae: "",
  opt_tras_inscription: "",
  opt_tras_opt:"",
  opt_tras_licenseplate: "",
  opt_tras_economicactivity: "",
  
  formoritrasstore_id: 0,
  ori_tras_store_id : 0,
  ori_tras_documnettype_id :1,
  ori_tras_documentid : "",
  ori_tras_tradename : "",
  ori_tras_name : "",
  ori_tras_contactname : "",
  ori_tras_roadtype :  "",
  ori_tras_street : "",
  ori_tras_country_id: 1,
  ori_tras_country_name: "",
  ori_tras_province_id: 30,
  ori_tras_province_name: "",
  ori_tras_postalcode_id: 6911,
  ori_tras_postalcode_code: "",
  ori_tras_postalcode_name: "",
  ori_tras_community_id: 6,
  ori_tras_community_name: "",
  ori_tras_phone: "",
  ori_tras_email: "",
  ori_tras_nima: "",
  ori_tras_cnae: "",
  ori_tras_inscription: "",
  ori_tras_opt:"",
  ori_tras_licenseplate: "",
  ori_tras_economicactivity: "",
  
  aut_tras_store_id : 0,
  aut_tras_documnettype_id : 1,
  aut_tras_documentid : "",
  aut_tras_tradename : "",
  aut_tras_name : "",
  aut_tras_contactname : "",
  aut_tras_roadtype : "",
  aut_tras_street : "",
  aut_tras_country_id: 1,
  aut_tras_country_name: "",
  aut_tras_province_id: 30,
  aut_tras_province_name: "",
  aut_tras_postalcode_id: 6911,
  aut_tras_postalcode_code: "",
  aut_tras_postalcode_name: "",
  aut_tras_community_id: 6,
  aut_tras_community_name: "",
  aut_tras_phone: "",
  aut_tras_email: "",
  aut_tras_nima: "",
  aut_tras_cnae: "",
  aut_tras_inscription: "",
  aut_tras_opt:"",
  aut_tras_licenseplate: "",
  aut_tras_economicactivity: "",
  
  formdesttrasstore_id: 0,
  dest_tras_store_id : 0,
  dest_tras_documnettype_id :1,
  dest_tras_documentid : "",
  dest_tras_tradename : "",
  dest_tras_name : "",
  dest_tras_contactname : "",
  dest_tras_roadtype : "",
  dest_tras_street : "",
  dest_tras_country_id: 1,
  dest_tras_country_name: "",
  dest_tras_province_id: 30,
  dest_tras_province_name: "",
  dest_tras_postalcode_id:6911,
  dest_tras_postalcode_code: "",
  dest_tras_postalcode_name: "",
  dest_tras_community_id: 6,
  dest_tras_community_name: "",
  dest_tras_phone: "",
  dest_tras_email: "",
  dest_tras_nima: "",
  dest_tras_cnae: "",
  dest_tras_inscription: "",
  dest_tras_opt:"",
  dest_tras_licenseplate: "",
  dest_tras_economicactivity: "",
 
  aut_dest_store_id : 0,
  aut_dest_documnettype_id :1,
  aut_dest_documentid : "",
  aut_dest_tradename : "",
  aut_dest_name : "",
  aut_dest_contactname : "",
  aut_dest_roadtype : "",
  aut_dest_street : "",
  aut_dest_country_id: 1,
  aut_dest_country_name: "",
  aut_dest_province_id: 30,
  aut_dest_province_name: "",
  aut_dest_postalcode_id: 6911,
  aut_dest_postalcode_code: "",
  aut_dest_postalcode_name: "",
  aut_dest_community_id: 6,
  aut_dest_community_name: "",
  aut_dest_phone: "",
  aut_dest_email: "",
  aut_dest_nima: "",
  aut_dest_cnae: "",
  aut_dest_inscription: "",
  aut_dest_opt:"",
  aut_dest_licenseplate: "",
  aut_dest_economicactivity: "",

  codeler_id : 0,
  codeler_code : "",
  codeler_namees : "",
  codeler_nameen : "",
  description_id : 0,
  description_code : "",
  description_namees : "",
  description_nameen : "",
  
  treatmenttypeorigin_id : 0,
  treatmenttypeorigin_code : "",
  treatmenttypeorigin_namees : "",
  treatmenttypeorigin_nameen : "",
 
  treatmenttypedestine_id : 0,
  treatmenttypedestine_code : "",
  treatmenttypedestine_namees : "",
  treatmenttypedestine_nameen : "",
  
  processtypepeorigin_id : 0,
  processtypepeorigin_code : "",
  processtypepeorigin_namees : "",
  processtypepeorigin_nameen : "",

  processtypedestine_id : 0,
  processtypedestine_code : "",
  processtypedestine_namees : "",
  processtypedestine_nameen : "",
  
  dangerousness_id : 0,
  dangerousness_namees : "",
  dangerousness_nameen : "",

  charac_danger : "",
  amount : 0,

  formreltransstore_id: 0,
  rel_trans_store_id : 0,
  rel_trans_documnettype_id : 0,
  rel_trans_documentid : "",
  rel_trans_tradename : "",
  rel_trans_name : "",
  rel_trans_contactname : "",
  rel_trans_roadtype :  "",
  rel_trans_street : "",
  rel_trans_country_id: 0,
  rel_trans_country_name : "",
  rel_trans_province_id: 0,
  rel_trans_province_name : "",
  rel_trans_postalcode_id:0,
  rel_trans_postalcode_code : "",
  rel_trans_postalcode_name : "",
  rel_trans_community_id: 0,
  rel_trans_community_name : "",
  rel_trans_phone: "",
  rel_trans_email: "",
  rel_trans_nima: "",
  rel_trans_cnae: "",
  rel_trans_inscription: "",
  rel_trans_opt:"",
  rel_trans_licenseplate: "",
  rel_trans_economicactivity: "",
  
  formrespprodstore_id: 0,
  resp_prod_store_id : 0,
  resp_prod_documnettype_id : 1,
  resp_prod_documentid : "",
  resp_prod_tradename : "",
  resp_prod_name : "",
  resp_prod_contactname : "",
  resp_prod_roadtype : "",
  resp_prod_street : "",
  resp_prod_country_id: 1,
  resp_prod_country_name: "",
  resp_prod_province_id: 30,
  resp_prod_province_name: "",
  resp_prod_postalcode_id:6911,
  resp_prod_postalcode_code: "",
  resp_prod_postalcode_name: "",
  resp_prod_community_id: 6,
  resp_prod_community_name: "",
  resp_prod_phone: "",
  resp_prod_email: "",
  resp_prod_nima: "",
  resp_prod_cnae: "",
  resp_prod_inscription: "",
  resp_prod_opt:"",
  resp_prod_licenseplate: "",
  resp_prod_economicactivity: "" 

}; 

const initialStateEMAIL = {
  "id":"",
  "defaultStore_id":0, 
  "useraccount_id":0,
  "store_EmailTo":"",
  "subjectEmail":"",
  "contentEmail":"",
  "filetosend":[] 
}; 

const initialEmailToSelect = [{
  "id": "",
  "email": "" 
}];

const NTSendEmail = ({id, showModalNTSendEmail}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token);   
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const footeremail = useSelector((state) => state.loginUser.defaultticketsformat.footeremail);
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);  
  const sendbyemail_form_opt_tras = useSelector((state) => state.formatDIUser.sendbyemail_form_opt_tras);
  const sendbyemail_form_ori_tras = useSelector((state) => state.formatDIUser.sendbyemail_form_ori_tras);
  const sendbyemail_form_aut_tras = useSelector((state) => state.formatDIUser.sendbyemail_form_aut_tras);
  const sendbyemail_form_aut_dest = useSelector((state) => state.formatDIUser.sendbyemail_form_aut_dest);
  const sendbyemail_form_dest_tras = useSelector((state) => state.formatDIUser.sendbyemail_form_dest_tras);
  const sendbyemail_form_rel_trans = useSelector((state) => state.formatDIUser.sendbyemail_form_rel_trans);
  const sendbyemail_form_resp_prod = useSelector((state) => state.formatDIUser.sendbyemail_form_resp_prod);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const [dataForm, setDataForm] = useState(initialStateFormNT);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [formEMAIL, setFormEMAIL] = useState(initialStateEMAIL);
  const [errorsEMAIL, setErrorsEMAIL] = useState({});
  const [pdfBlob, setPdfBlob] = useState(null); 
  const [emailToSelect,setEmailToSelect]= useState(initialEmailToSelect);  
  const [filteredEmail, setFilteredEmail] = useState([]); // Opciones filtradas
  const [highlightedIndexEmail, setHighlightedIndexEmail] = useState(-1); // Índice de la opción resaltada 
  const [pdfUrl, setPdfUrl] = useState(""); // Estado para actualizar el PDF

  const PdfViewer = useMemo(() => {
    return pdfUrl?
      <iframe
        src={pdfUrl} 
        title="PDF Preview"
        style={{ width: '100%', height: '100%', border: 'none' }}
      /> 
    :pdfBlob ? (
      <iframe
        src={URL.createObjectURL(pdfBlob)}
        title="PDF Preview"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    ) : null;
  }, [pdfBlob,pdfUrl]);

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalNTSendEmail) {
        setDataForm(initialStateFormNT);
        dispatch(setLoading(false));  
        setPdfBlob(null); 
        setFormEMAIL(initialStateEMAIL);
        setErrorsEMAIL({});
        setEmailToSelect(initialEmailToSelect);
        setFilteredEmail([]);
        setHighlightedIndexEmail(-1); 
        setPdfUrl("");
        navigate("/nt");
      }
    },
    [
      setDataForm,  
      setPdfBlob,    
      showModalNTSendEmail,
      setEmailToSelect,
      setFilteredEmail,
      setHighlightedIndexEmail,
      setPdfUrl, 
      dispatch,
      navigate]
  );
  
  const handleCloseSendEmailNT = () => {
    setDataForm(initialStateFormNT);
    dispatch(setLoading(false));
    setPdfBlob(null);   
    setFormEMAIL(initialStateEMAIL);
    setErrorsEMAIL({});
    setEmailToSelect(initialEmailToSelect);
    setFilteredEmail([]);
    setPdfUrl("");
    setHighlightedIndexEmail(-1); 
    navigate("/nt");
	};

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
  };
  // Dentro del componente
  const debouncedHandleSearchEmail= useDebounce((searchValue) => {
    const upperValue = searchValue.toLowerCase();
    if (upperValue.trim() === "") {
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
      return;
    }
    const filtered = emailToSelect
        .filter(store => store && store.email)
        .filter(store => {
        const emails = store.email.toLowerCase();
        return emails.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
      setFilteredEmail(filtered);
      setHighlightedIndexEmail(0);
  }, 300); 
  const handleSelectEmail = (email) => {
    if (!email) return; // Validación adicional para evitar errores
    setFormEMAIL((formEMAIL) => ({
      ...formEMAIL,
      store_EmailTo: email.email || ""
      
    }));
    setFilteredEmail([]);
    setHighlightedIndexEmail(-1);
  }; 

  const handleKeyDownEmail = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredEmail.length === 0 && formEMAIL.store_EmailTo.trim() === "") {
        setFilteredEmail(emailToSelect);
        setHighlightedIndexEmail(0);
      } else {
        setHighlightedIndexEmail((prevIndex) => {
          const nextIndex = prevIndex < filteredEmail.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexEmail((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexEmail >= 0) {
      if (highlightedIndexEmail >= 0 && highlightedIndexEmail < filteredEmail.length) {
        handleSelectEmail(filteredEmail[highlightedIndexEmail]);
      }
    } else if (event.key === "Escape") {
      const isValid = emailToSelect.some((email) => {
        if (!email || !email.workplace) return false; 
        const normalizedEmail = email.email.toLowerCase();
        const normalizedInputEmail = formEMAIL.store_EmailTo.toLowerCase();
        return normalizedEmail === normalizedInputEmail;
      }); 
      if (!isValid) {
        setFormEMAIL((formEMAIL) => ({
          ...formEMAIL,
          store_EmailTo: "",
        }));
      } 
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
    }
  };

  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  
   const handleBlur = useCallback((event) => {
       if (!event || !event.currentTarget) return;
       // Asegúrate de que no se cierra si haces clic en un elemento de la lista
       if (!event.currentTarget.contains(event.relatedTarget)) {
        setFilteredEmail([]);
        setHighlightedIndexEmail(-1);
      }
    }, []);
    

  const handleBlurDataEditEmail = (e) => {
    handleChangeDataEditEmail(e);
    setErrorsEMAIL(validateFormEmail());
  };

  const handleChangeDataEditEmail = (e) => {
    const { name, value } = e.target;
    setFormEMAIL(formEMAIL => ({
      ...formEMAIL,
      [name]: value,
    })); 
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob); // ✅ Convierte el Blob a Base64
      reader.onloadend = () => resolve(reader.result.split(",")[1]); // ✅ Remueve "data:application/pdf;base64,"
      reader.onerror = reject;
    });
  };

  const validateFormEmail = () => {
    let errorsEMAIL = {};
    //let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (!formEMAIL.store_EmailTo || formEMAIL.store_EmailTo==="") {
      errorsEMAIL.store_EmailTo = 'Text_FieldSendEmailToRequired'; 
    } else {
      if (regexInvalidCharacters.test(formEMAIL.store_EmailTo)) {
        errorsEMAIL.store_EmailTo = 'Text_TextNoValid';
      }
    }  

    if (regexInvalidCharacters.test(formEMAIL.subjectEmail)) {
      errorsEMAIL.subjectEmail = 'Text_TextNoValid';
    }

    if (regexInvalidCharacters.test(formEMAIL.contentEmail)) {
      errorsEMAIL.contentEmail = 'Text_TextNoValid';
    }  
    return errorsEMAIL;
  };

  const handleConfirmFetchSendFNT = async (formData) => { 
    handleCloseSendEmailNT(); 
    const fetchData = async () => {  
      try {
        const getData = await helpHttp().postemail(ENDPOINT, `api/sendemailwithattachment`, token,formData);
        if (getData.status === "OK") {
          dispatch(setLoading(false));
          dispatch(successErrorAction(t('Text_EMAIL_Sended')));
        } else {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.cause)));
        } 
      } catch (error) { 
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }   
      return () => {  };
    }; 
    fetchData();  
  };
 
  const handleSubmitSendEmail =  async ()=>{
    const errors = validateFormEmail();
    setErrorsEMAIL(errors);  
    const hasNoErrors = Object.keys(errors).length === 0;
    const emailToOk = formEMAIL?.store_EmailTo?.trim();
    const hasPdf = !!pdfBlob || !!pdfUrl;
    if (!hasNoErrors || !emailToOk || !hasPdf) {
       if (errors.store_EmailTo) dispatch(warningErrorAction(t(errors.store_EmailTo)));
       else if (errors.subjectEmail) dispatch(warningErrorAction(t(errors.subjectEmail)));
       else if (errors.contentEmail) dispatch(warningErrorAction(t(errors.contentEmail)));
       else if (!hasPdf) dispatch(warningErrorAction(t("Text_FieldSendEmailToRequired")));
       else dispatch(warningErrorAction(t("Text_IncorrectData")));
       return;
     } 
    dispatch(setLoading(true));
    if (pdfBlob){
        // ✅ Convertir Blob a Base64 sin detener la ejecución
      blobToBase64(pdfBlob)
      .then((base64File) => {
        const formData = {
          id: id,
          defaultStore_id: defaultStore.id,
          useraccount_id: useraccount_id,
          store_EmailTo: formEMAIL.store_EmailTo,
          subjectEmail: formEMAIL.subjectEmail,
          contentEmail: formEMAIL.contentEmail,
          filetosend: base64File, 
          fileName: (dataForm.number_nt!==undefined && dataForm.number_nt!=="" )?`NT_${dataForm.number_nt}.pdf`:`NT_${id.toString().padStart(8, '0')}.pdf`,
          fileType: "application/pdf",
        }; 
        // ✅ Llamada asíncrona sin bloquear el flujo 
        handleConfirmFetchSendFNT(formData);
      })
      .catch((error) => {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }); 
    }else{
      if (pdfUrl) {
        fetch(pdfUrl)
          .then(response => response.blob()) // Convertir la URL en un Blob
          .then(blob => blobToBase64(blob)) // Convertir el Blob en Base64
          .then((base64File) => {
            const formData = {
              id: id,
              defaultStore_id: defaultStore.id,
              useraccount_id: useraccount_id,
              store_EmailTo: formEMAIL.store_EmailTo,
              subjectEmail: formEMAIL.subjectEmail,
              contentEmail: formEMAIL.contentEmail,
              filetosend: base64File,
              fileName: (dataForm.number_nt !== undefined && dataForm.number_nt !== "") 
                ? `NT_${dataForm.number_nt}.pdf` 
                : `NT_${id.toString().padStart(8, '0')}.pdf`,
              fileType: "application/pdf",
            };
            // ✅ Llamada asíncrona sin bloquear el flujo
            handleConfirmFetchSendFNT(formData);
          })
          .catch((error) => {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData')));
          });
      } 
    }  
  };  
  
  useEffect(() => {
    let isMounted = true; 
    const fetchDataEmail = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`api/getlistemails/`,token,
          (formEMAIL.store_EmailTo!==undefined && formEMAIL.store_EmailTo!==null && formEMAIL.store_EmailTo.replace(/[.;\-/\\|]/g, "").trim()!=="")?formEMAIL.store_EmailTo.replace(/[.;\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setEmailToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    
    if (showModalNTSendEmail && formEMAIL.store_EmailTo && formEMAIL.store_EmailTo.replace(/[.;\-/\\|]/g, "").trim()!=="") { 
      fetchDataEmail();
    }else{
      setEmailToSelect(initialEmailToSelect);
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,showModalNTSendEmail,formEMAIL.store_EmailTo]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (pdfBlob) { 
      const formatted_id= (dataForm.number_nt!==undefined && dataForm.number_nt!=="")?`NT_${dataForm.number_nt}.pdf`:`NT_${id.toString().padStart(8, '0')}.pdf`;
      const file = new File([pdfBlob], formatted_id, { type: "application/pdf" });
      setFormEMAIL((formEMAIL) => ({
        ...formEMAIL,
        filetosend: file // Se almacena directamente como un único archivo
      }));
    }
  }, [pdfBlob,id,dataForm.number_nt]);    
  
  useEffect(() => {
    let isMounted = true;
    const fetchFileForm = async (fileName) => {
       try {
        const getData = await helpHttp().getfilesupload(ENDPOINT, `pdftos3uploader/downloadfroms3`, token,fileName);
        if (!getData) { 
          setPdfUrl("");
          dispatch(warningErrorAction(t('Text_ConnectionFailed'))); 
        } else{ 
          if (getData && getData.size>0){
            const url = URL.createObjectURL(getData);
            setPdfUrl(url); // Guardar la URL del PDF para mostrarlo en <iframe>  
          } 
        }
      } catch (error) {
        setPdfUrl("");
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    const fetchDataFormDI = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get2(ENDPOINT, `nt/getntpdfbyid/`, token, id);
        if (getData.err) {
          setDataForm(initialStateFormNT); 
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataForm(getData);
          setFormEMAIL(formEMAIL => ({
            ...formEMAIL,
            defaultStore_id:defaultStore.id,
            useraccount_id:useraccount_id,
            store_EmailTo: [...new Set(
              [ sendbyemail_form_opt_tras?getData.opt_tras_email:'',
                sendbyemail_form_ori_tras?getData.ori_tras_email:'',
                sendbyemail_form_aut_tras?getData.aut_tras_email:'',
                sendbyemail_form_aut_dest?getData.aut_dest_email:'',
                sendbyemail_form_dest_tras?getData.dest_tras_email:'',
                sendbyemail_form_rel_trans?getData.rel_trans_email:'',
                sendbyemail_form_resp_prod?getData.resp_prod_email:'']
                .filter(email => email && email.trim() !== "")
                .map(email => email.trim().toLowerCase()) // opcional: para evitar duplicados por mayúsculas/minúsculas
            )].join(";"),
            subjectEmail:"LE REMITO LA NOTIFICACIÓN PREVIA Nº: "+getData.number_nt,
            contentEmail:footeremail
          })); 
        
          if (getData.isScanned){
            setPdfBlob(null)
            let fileName = "NT_"+getData.number_nt+ ".pdf"; 
            fetchFileForm(fileName); 
          } 
          dispatch(setLoading(false));
        }  
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    if (id!=="0"){
      if (!dataForm.id || dataForm.id==="" || dataForm.id===0){
        fetchDataFormDI(); 
        dispatch(setLoading(false));
      }
    }else{
      setDataForm(initialStateFormNT);
      setFormEMAIL(formEMAIL => ({
        ...formEMAIL,
        defaultStore_id:defaultStore.id,
        useraccount_id:useraccount_id,
        contentEmail:footeremail
      })); 
      dispatch(setLoading(false));
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,pdfBlob,dataForm.id,defaultStore.id,useraccount_id,footeremail,defaulttypesdi,sendbyemail_form_opt_tras,sendbyemail_form_ori_tras,sendbyemail_form_aut_dest,sendbyemail_form_aut_tras,sendbyemail_form_dest_tras,sendbyemail_form_rel_trans,sendbyemail_form_resp_prod]);  

  return (
    <>
      {showModalNTSendEmail ? ( 
        <div className="container-fluid email-send-wrapper">
          <Box sx={{ bgcolor: '#ffffff', width: '1050px'}}>
            <form onSubmit={handleCloseSendEmailNT}>  
              {/* HEADER */}
              <div className="email-card-header">
                <div className="email-header-content">
                  <div className="email-header-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="email-header-text">
                    <div className="email-header-title">
                      {t('Text_NumberNT_EMAIL')}:
                    </div>
                    <div className="email-header-number">
                      {dataForm.number_nt}
                    </div>
                  </div>
                  <div className="email-card-actions">
                    {!isLoadingData && (
                      <>
                        <button type="button" className="email-send-btn" onClick={handleSubmitSendEmail} >
                          {t('Button_SEND')}
                          <SendIcon sx={{ fontSize: 22, color: "white" }} />
                        </button>
                        <button type="button" className="email-cancel-btn" onClick={handleCloseSendEmailNT} >
                          {t('Button_Cancel')}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* FORM CARD */}
              {!isLoadingData ? (
                <>
                  <div className="email-card-form">
                    <div className="row g-3">
                      {/* Email To */}
                      <div className="col-12 email-input" style={{ position: 'relative' }}>
                        <label className="text-primary" style={{ fontSize: 18 }}>
                          {t('Text_SENDEMAIL_EmailsTo')} :
                        </label>
                        <TextField
                          id="store_EmailTo"
                          name="store_EmailTo"
                          value={formEMAIL.store_EmailTo}
                          onChange={(e) => {
                            setFormEMAIL(prev => ({ ...prev, store_EmailTo: e.target.value.toLowerCase() }));
                            debouncedHandleSearchEmail(e.target.value);
                          }}
                          onKeyDown={handleKeyDownEmail}
                          onBlur={(event) => {
                            if (!event.relatedTarget || !event.relatedTarget.closest(".email-suggest-dropdown")) {
                              handleBlur();
                            }
                          }}
                          label={
                            errorsEMAIL.store_EmailTo != null
                              ? t(errorsEMAIL.store_EmailTo)
                              : t('PlaceHolder_SENDEMAIL_EmailsTo')
                          }
                          placeholder={t('PlaceHolder_SENDEMAIL_EmailsTo')}
                          variant="standard"
                          inputProps={{ style: { width: i18n.language === 'es' ? 738 : 867 } , maxLength: 100 }}
                          InputLabelProps={{ style: { fontSize: 18, background: '#FFFFFF' } }}
                        />

                        {filteredEmail.length > 0 && (
                          <div className="email-suggest-dropdown" onMouseDown={(e) => e.preventDefault()}>
                            {filteredEmail.map((store, index) => (
                              <MenuItem
                                key={store.id}
                                onClick={() => handleSelectEmail(store)}
                                style={{
                                  cursor: "pointer",
                                  padding: "10px 12px",
                                  borderBottom: "1px solid #eee",
                                  fontSize: 18,
                                  backgroundColor: index === highlightedIndexEmail ? "#4e73df" : "transparent",
                                  color: index === highlightedIndexEmail ? "white" : "black",
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                {store.email}
                              </MenuItem>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Subject */}
                      <div className="col-12 email-input">
                        <label className="text-primary" style={{ fontSize: 18 }}>
                          {t('Text_SENDEMAIL_Subject')}
                        </label>
                        <TextField
                          id="subjectEmail"
                          name="subjectEmail"
                          value={formEMAIL.subjectEmail ?? ""}
                          inputProps={{ style: { width: i18n.language === "es" ? 941 : 937 }, maxLength: 100 }}
                          InputLabelProps={{ style: { fontSize: 18, background: '#FFFFFF' } }}
                          label={
                            errorsEMAIL.subjectEmail != null
                              ? t(errorsEMAIL.subjectEmail)
                              : t('PlaceHolder_SENDEMAIL_Subject')
                          }
                          placeholder={t('PlaceHolder_SENDEMAIL_Subject')}
                          variant="standard"
                          onBlur={handleBlurDataEditEmail}
                          onChange={handleChangeDataEditEmail}
                        />
                      </div>

                      {/* Content */}
                      <div className="col-12">
                        <label className="text-primary" style={{ fontSize: 18 }}>
                          {t('Text_SENDEMAIL_Content')} :
                        </label>
                        <Textarea
                          id="contentEmail"
                          name="contentEmail"
                          value={formEMAIL.contentEmail}
                          className="email-textarea"
                          label={
                            errorsEMAIL.contentEmail != null
                              ? t(errorsEMAIL.contentEmail)
                              : t('PlaceHolder_SENDEMAIL_Content')
                          }
                          placeholder={t('PlaceHolder_SENDEMAIL_Content')}
                          sx={{ width: 1020, fontSize: 18 }}
                          variant="standard"
                          onBlur={handleBlurDataEditEmail}
                          onChange={handleChangeDataEditEmail}
                          maxRows={8}
                        />
                      </div>
                    </div>
                  </div> 
                  {/* PDF CARD */}
                  <div className="email-card-pdf">
                    {PdfViewer}
                  </div>
                </>
              ):
                <LoadingNews/>
              }
            </form>
          </Box>  
          {!pdfUrl &&  <ReportTemplateNT dataForm={dataForm} setPdfBlob={setPdfBlob} />}
          <br />
        </div>
      ) : null}
    </>
  )    
}

NTSendEmail.propTypes = {
  id: PropTypes.string.isRequired,
  showModalNTSendEmail: PropTypes.bool.isRequired
};

export default NTSendEmail;